import React from 'react'
import styled from 'styled-components'

import { FONTS } from '../../../../../constants'

export const TitleRow = () => {
  return (
    <Root>
      <Type>
        <span>Type</span>
      </Type>
      <SaleGroup>
        <span>Sale Group</span>
      </SaleGroup>
      <SubProjectCode>
        <span>Sub-proj. Code</span>
      </SubProjectCode>
      <Description>
        <span>Description</span>
      </Description>
      <DeliveryPlan>
        <span>Delivery Plan</span>
      </DeliveryPlan>
      <CreditTerm>
        <span>Credit Term</span>
      </CreditTerm>
      <Cost>
        <span>Costs</span>
      </Cost>
      <Price>
        <span>Prices</span>
      </Price>
    </Root>
  )
}

const Root = styled.div`
    width: 100%;
    height: 25px;
    display: grid;
    grid-gap: 0 10px;
    grid-template-columns: 3fr 3fr 3fr 4fr 3fr 2fr 3fr 3fr;
    grid-auto-rows: 25px;
    background: #616161;
    padding: 0 24px;
`

const Type = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;

    span {
        font-family: ${FONTS.GOTHAM};
        font-size: ${FONTS.SMALL_SIZE};
        color: #FFFFFF;
    }
`

const SaleGroup = styled(Type)`
`

const SubProjectCode = styled(Type)`
`

const Description = styled(Type)`
`

const DeliveryPlan = styled(Type)`
`

const CreditTerm = styled(Type)`
`

const Cost = styled(Type)`
    justify-content: flex-end;
`

const Price = styled(Type)`
    justify-content: flex-end;
`




// WEBPACK FOOTER //
// ./src/components/project-code/project-detail/cost-planning/tab-pane-licensing/title-row.js